import React, { useState } from 'react';
import { Container, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Inventario.css';
import ListaTratamientos from './ListaTratamientos';
import Productos from '../Productos/ListaProductos';

const Inventario = () => {
  const [activeTab, setActiveTab] = useState('tratamientos');

  // Modal Tratamiento
  const [openModalTratamiento, setOpenModalTratamiento] = useState(false);
  const [nuevoTratamiento, setNuevoTratamiento] = useState({
    nombre_tratamiento: '',
    duracion_tratamiento: '',
    precio_tratamiento: '',
    marca: ''
  });

  // Modal Producto
  const [openModalProducto, setOpenModalProducto] = useState(false);
  const [nuevoProducto, setNuevoProducto] = useState({
    nombre_producto: '',
    cantidad: '',
    precio_producto: ''
  });

  // Refresh
  const [refreshTratamientos, setRefreshTratamientos] = useState(false);
  const [refreshProductos, setRefreshProductos] = useState(false);

  const handleTabChange = (tab) => setActiveTab(tab);

  // ===================== TRATAMIENTO =====================
  const handleOpenModalTratamiento = () => setOpenModalTratamiento(true);
  const handleCloseModalTratamiento = () => {
    setOpenModalTratamiento(false);
    setNuevoTratamiento({ nombre_tratamiento: '', duracion_tratamiento: '', precio_tratamiento: '', marca: '' });
  };
  const handleInputChangeTratamiento = (e) => {
    const { name, value } = e.target;
    setNuevoTratamiento(prev => ({ ...prev, [name]: value }));
  };
  const handleCrearTratamiento = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/creartratamientos`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(nuevoTratamiento),
      });
      const data = await response.json();
      if (response.ok) {
        setRefreshTratamientos(prev => !prev); // Dispara actualización de ListaTratamientos
        handleCloseModalTratamiento();
      } else {
        alert(data.message || 'Error al crear tratamiento');
      }
    } catch (error) {
      console.error('Error al crear tratamiento:', error);
      alert('Error al crear tratamiento');
    }
  };

  // ===================== PRODUCTO =====================
  const handleOpenModalProducto = () => setOpenModalProducto(true);
  const handleCloseModalProducto = () => {
    setOpenModalProducto(false);
    setNuevoProducto({ nombre_producto: '', cantidad: '', precio_producto: '' });
  };
  const handleInputChangeProducto = (e) => {
    const { name, value } = e.target;
    setNuevoProducto(prev => ({ ...prev, [name]: value }));
  };
  const handleCrearProducto = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/productos`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(nuevoProducto),
      });
      const data = await response.json();
      if (response.ok) {
        setRefreshProductos(prev => !prev); // Dispara actualización de Productos
        handleCloseModalProducto();
      } else {
        alert(data.message || 'Error al crear producto');
      }
    } catch (error) {
      console.error('Error al crear producto:', error);
      alert('Error al crear producto');
    }
  };

  return (
    <div className="inventario-contenedor">
      <div className="inventario-header">
        <div className="left-options">
          <span className={`header-item ${activeTab === 'tratamientos' ? 'active' : ''}`} onClick={() => handleTabChange('tratamientos')}>Tratamientos</span>
          <span className={`header-item ${activeTab === 'productos' ? 'active' : ''}`} onClick={() => handleTabChange('productos')}>Productos</span>
        </div>
        <div className="right-options">
          <Button variant="contained" color="primary" onClick={activeTab === 'tratamientos' ? handleOpenModalTratamiento : handleOpenModalProducto}>
            {activeTab === 'tratamientos' ? '+ Tratamiento' : '+ Producto'}
          </Button>
        </div>
      </div>

      <Container className="info-contenedor-inventario">
        {activeTab === 'tratamientos' ? (
          <ListaTratamientos refresh={refreshTratamientos} />
        ) : (
          <Productos refresh={refreshProductos} />
        )}
      </Container>

      {/* ===================== MODAL TRATAMIENTO ===================== */}
      <Dialog open={openModalTratamiento} onClose={handleCloseModalTratamiento}>
        <DialogTitle>Agregar Nuevo Tratamiento</DialogTitle>
        <DialogContent>
          <TextField label="Nombre del Tratamiento" name="nombre_tratamiento" value={nuevoTratamiento.nombre_tratamiento} onChange={handleInputChangeTratamiento} fullWidth margin="normal" />
          <TextField label="Duración (min)" name="duracion_tratamiento" type="number" value={nuevoTratamiento.duracion_tratamiento} onChange={handleInputChangeTratamiento} fullWidth margin="normal" />
          <TextField label="Precio (€)" name="precio_tratamiento" type="number" value={nuevoTratamiento.precio_tratamiento} onChange={handleInputChangeTratamiento} fullWidth margin="normal" />
          <FormControl fullWidth margin="normal">
            <InputLabel>Marca</InputLabel>
            <Select name="marca" value={nuevoTratamiento.marca || ''} onChange={handleInputChangeTratamiento}>
              <MenuItem value="sweet">🧴 Sweet</MenuItem>
              <MenuItem value="icon">💎 Icon</MenuItem>
              <MenuItem value="especial">✨ Mayores 65</MenuItem>
              <MenuItem value="lista">🧾 Lista Servicios</MenuItem>
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModalTratamiento} color="secondary">Cancelar</Button>
          <Button onClick={handleCrearTratamiento} color="primary">Guardar</Button>
        </DialogActions>
      </Dialog>

      {/* ===================== MODAL PRODUCTO ===================== */}
      <Dialog open={openModalProducto} onClose={handleCloseModalProducto}>
        <DialogTitle>Agregar Nuevo Producto</DialogTitle>
        <DialogContent>
          <TextField label="Nombre Producto" name="nombre_producto" value={nuevoProducto.nombre_producto} onChange={handleInputChangeProducto} fullWidth margin="normal" />
          <TextField label="Cantidad" name="cantidad" type="number" value={nuevoProducto.cantidad} onChange={handleInputChangeProducto} fullWidth margin="normal" />
          <TextField label="Precio (€)" name="precio_producto" type="number" value={nuevoProducto.precio_producto} onChange={handleInputChangeProducto} fullWidth margin="normal" />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModalProducto} color="secondary">Cancelar</Button>
          <Button onClick={handleCrearProducto} color="primary">Guardar</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default Inventario;
